module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-FC-Auto-Driver.78a3d428.gif";